import { useState } from "react";
import "./App.css";
import { BrowserRouter } from "react-router-dom";
import SplashScreen from "./components/SplashScreen";
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import QuickInfoBar from "./components/QuickInfoBar";
import StudiosSection from "./components/StudiosSection";
import PortfolioSection from "./components/PortfolioSection";
import ConventionSection from "./components/ConventionSection";
import TeamSection from "./components/TeamSection";
import PricingSection from "./components/PricingSection";
import VoucherSection from "./components/VoucherSection";
import ApplicationSection from "./components/ApplicationSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import CookieBanner from "./components/CookieBanner";
import { AnimatePresence } from "framer-motion";

function App() {
  const [splashDone, setSplashDone] = useState(false);

  return (
    <BrowserRouter>
      <div className="App bg-[#0A0A0A] text-[#F0F0F0] font-outfit overflow-x-hidden">
        <AnimatePresence>
          {!splashDone && (
            <SplashScreen key="splash" onComplete={() => setSplashDone(true)} />
          )}
        </AnimatePresence>

        <div style={{ opacity: splashDone ? 1 : 0, transition: "opacity 0.5s ease" }}>
          <Header />
          <main>
            <HeroSection />
            <QuickInfoBar />
            <StudiosSection />
            <PortfolioSection />
            <ConventionSection />
            <TeamSection />
            <PricingSection />
            <VoucherSection />
            <ApplicationSection />
            <ContactSection />
          </main>
          <Footer />
          <CookieBanner />

          {/* Floating CTA – Mobile Only */}
          <a
            href="#kontakt"
            data-testid="floating-cta"
            className="fixed bottom-6 left-1/2 -translate-x-1/2 z-40 md:hidden bg-[#C9A84C] text-[#0A0A0A] font-semibold px-8 py-3 text-xs tracking-[0.2em] uppercase shadow-[0_0_20px_rgba(201,168,76,0.5)] animate-gold-pulse whitespace-nowrap"
          >
            Termin anfragen
          </a>
        </div>
      </div>
    </BrowserRouter>
  );
}

export default App;
